// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Vetting20Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Vetting20: FC<Vetting20Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="20"
            height="20"
        >
            <path d="M13.896 8.063 8.938 13l-2.834-2.812 1.062-1.063 1.772 1.75L12.833 7l1.063 1.063Z" />
            <path
                d="M8.145 2.448a2.329 2.329 0 0 1 3.71 0 2.329 2.329 0 0 0 2.173.899 2.33 2.33 0 0 1 2.625 2.625l-.016.156a2.33 2.33 0 0 0 .916 2.017 2.33 2.33 0 0 1 0 3.71l-.122.1a2.33 2.33 0 0 0-.778 2.074 2.329 2.329 0 0 1-2.624 2.624 2.33 2.33 0 0 0-2.173.9l-.09.111a2.33 2.33 0 0 1-3.531 0l-.09-.111a2.33 2.33 0 0 0-2.173-.9l-.143.015a2.33 2.33 0 0 1-2.482-2.64 2.33 2.33 0 0 0-.777-2.074l-.123-.098a2.329 2.329 0 0 1-.11-3.621l.11-.09a2.33 2.33 0 0 0 .917-2.017l-.017-.156a2.33 2.33 0 0 1 2.625-2.625 2.329 2.329 0 0 0 2.073-.777l.1-.122Zm2.515.906a.828.828 0 0 0-1.32 0 3.83 3.83 0 0 1-3.573 1.48.829.829 0 0 0-.934.933 3.83 3.83 0 0 1-1.48 3.573.828.828 0 0 0 0 1.32 3.83 3.83 0 0 1 1.48 3.573.83.83 0 0 0 .934.934 3.83 3.83 0 0 1 3.573 1.48.829.829 0 0 0 1.32 0 3.829 3.829 0 0 1 3.573-1.48.83.83 0 0 0 .934-.934 3.829 3.829 0 0 1 1.48-3.573.829.829 0 0 0 0-1.32 3.83 3.83 0 0 1-1.48-3.573.83.83 0 0 0-.934-.934 3.83 3.83 0 0 1-3.573-1.48Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Vetting20;
